export default __webpack_public_path__ + "static/media/IMG15.d0f88b41.jpg";